// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"bb2ce1cf80ddb8614c93","243":"307c1cf31df043fbcfea","595":"f7776ac79a7da92f941a","658":"31e31524de81d8ee600a","871":"e70ba9c3b13d579e6c33"}[chunkId] + ".bundle.js";
};